import { FormattedMessage, useIntl } from 'react-intl';
import { GreenLabel, LabelContainer, RedLabel, YellowLabel } from './styles';

function TrascriptionsLabel() {
  const { $t } = useIntl();

  const high = $t({
    id: 'audit.transcriptionScreen.high',
    defaultMessage: 'Alta',
  });

  const medium = $t({
    id: 'audit.transcriptionScreen.medium',
    defaultMessage: 'Media',
  });

  const low = $t({
    id: 'audit.transcriptionScreen.low',
    defaultMessage: 'Baja',
  });

  return (
    <LabelContainer>
      <FormattedMessage id="audit.transcriptionScreen.confidence" defaultMessage="Eficiencia" />
      <GreenLabel>{high}</GreenLabel>
      <YellowLabel>{medium}</YellowLabel>
      <RedLabel>{low}</RedLabel>
    </LabelContainer>
  );
}

export default TrascriptionsLabel;
